import { createRouter, createWebHistory } from 'vue-router'
import LayoutLoginView from '@/views/auth/layouts/LayoutAuth.vue'
import LayoutBasic from '@/views/layouts/LayoutBasic.vue'
import store from '@/store'

const routes = [
  {
    path: '/',
    component: LayoutLoginView,
    children: [
      {
        path: '/',
        name: 'login-index',
        meta: { redirectIfAuthenticated: true },
        redirect: { name: 'login'}
      },
      {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "login" */ '@/views/auth/login.vue'),
        meta: { redirectIfAuthenticated: true },
      },
      {
        path: '/forgot-password',
        component:  () => import(/* webpackChunkName: "forgot_password" */ '@/views/auth/ForgotPassword.vue') ,
        name: 'forgot-password',
        meta: { redirectIfAuthenticated: true },
      },
      {
        path: '/reset-password',
        component: () => import(/* webpackChunkName: "reset_password" */ '@/views/auth/ResetPassword.vue') ,
        name: 'reset-password',
        meta: { redirectIfAuthenticated: true },
      }
    ]
  },
  {
    path: '/admin',
    component: LayoutBasic,
    meta: { requiresAuth: true, title: 'navigation.dashboard' },
    children: [
      {
        path: '/admin',
        name: 'dashboard-home',
        component: () => import(/* webpackChunkName: "dashboard-home" */ '@/views/dashboard/Dashboard.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Dashboard.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'restaurants',
        name: 'restaurants-index',
        component: () => import(/* webpackChunkName: "restaurants-index" */ '@/views/restaurants/Index.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'restaurants/:id/view',
        component: () => import(/* webpackChunkName: "restaurants-view" */ '@/views/restaurants/View.vue'),
        meta: { requiresAuth: true },
        children: [
          {
            path: '',
            name: 'restaurants-view-informations',
            component: () => import(/* webpackChunkName: "restaurants-view-informations" */ '@/views/restaurants/Informations.vue'),
            meta: { requiresAuth: true },
          },
          {
            path: 'rooms',
            name: 'restaurants-view-rooms',
            component: () => import(/* webpackChunkName: "restaurants-view-rooms" */ '@/views/restaurants/Room.vue'),
            meta: { requiresAuth: true },
          },
          {
            path: 'qrcodes',
            name: 'restaurants-view-qrcodes',
            component: () => import(/* webpackChunkName: "restaurants-view-rooms" */ '@/views/restaurants/Qrcode.vue'),
            meta: { requiresAuth: true },
          },
          {
            path: 'reservations',
            name: 'restaurants-view-reservations',
            component: () => import(/* webpackChunkName: "restaurants-view-reservations" */ '@/views/restaurants/Reservation.vue'),
            meta: { requiresAuth: true },
          },
          {
            path: 'meals',
            name: 'restaurants-view-meals',
            component: () => import(/* webpackChunkName: "restaurants-view-meals" */ '@/views/restaurants/Meals.vue'),
            meta: { requiresAuth: true },
          },
          {
            path: 'meals',
            name: 'restaurants-view-meals',
            component: () => import(/* webpackChunkName: "restaurants-view-meals" */ '@/views/restaurants/Meals.vue'),
            meta: { requiresAuth: true },
          },
          {
            path: 'serveurs',
            name: 'restaurants-view-serveurs',
            component: () => import(/* webpackChunkName: "restaurants-view-serveurs" */ '@/views/restaurants/Serveur.vue'),
            meta: { requiresAuth: true },
          }
        ]
      },
      {
        path: 'meals',
        name: 'meal-index',
        component: () => import('@/views/Meal/Index.vue'),
        meta: { requiresAuth: true },
        children: [
          {
            path: 'category/:id/view',
            name: 'meal-category-view',
            component: () => import('@/views/Meal/ViewMeal.vue'),
            meta: { requiresAuth: true },
            children: [
              {
                path: 'list/:id',
                name: 'meal-category-list',
                component: () => import('@/views/Meal/MealByCategory.vue'),
                meta: { requiresAuth: true },
              },
            ]
          },
        ]
      },


      {
        path: 'orders/live',
        name: 'orders-live-index',
        component: () => import(/* webpackChunkName: "restaurants-index" */ '@/views/orders/Live.vue'),
        meta: { requiresAuth: true },
      },

      {
        path: 'meals/details',
        name: 'meal-detail',
        component: () => import(/* webpackChunkName: "restaurants-index" */ '@/views/Meal/Detail.vue'),
        meta: { requiresAuth: true },
      },
      {
        path: 'settings/meals',
        name: 'settings-meals-index',
        component: () => import(/* webpackChunkName: "Index" */ '@/views/settings/meal/Index.vue'),
        meta: { requiresAuth: true },
        children: [
          {
            path: '',
            name: 'categories-index',
            component: () => import(/* webpackChunkName: "Category" */ '@/views/settings/meal/Category.vue'),

            meta: { requiresAuth: true },
          },
          {
            path: 'accompaniments',
            name: 'accompaniment-index',
            component: () => import(/* webpackChunkName: "Accompaniment" */ '@/views/settings/meal/Accompaniment.vue'),
            meta: { requiresAuth: true },
          },
          {
            path: 'variations',
            name: 'variation-index',
            component: () => import(/* webpackChunkName: "Variation" */ '@/views/settings/meal/Variation.vue'),
            meta: { requiresAuth: true },
          },
        ]
      },
      {
        path: 'settings/systems',
        component: () => import(/* webpackChunkName: "restaurants-view" */ '@/views/settings/system/Index.vue'),
        meta: { requiresAuth: true },
        children: [
          {
            path: '',
            name: 'users',
            component: () => import(/* webpackChunkName: "Index" */ '@/views/user/Index.vue'),
            meta: { requiresAuth: true },
          },
          {
            path: 'user/:id/update',
            name: 'users-view',
            component: () => import(/* webpackChunkName: "Index" */ '@/views/user/View.vue'),
            meta: { requiresAuth: true },
          },
          {
            path: 'rights',
            name: 'right-index',
            component: () => import(/* webpackChunkName: "Right" */ '@/views/user/Right.vue'),
            meta: { requiresAuth: true },
          },

          {
            path: 'nps/questions',
            name: 'nps-question',
            component: () => import(/* webpackChunkName: "Question" */ '@/views/nps/Question.vue'),

            meta: { requiresAuth: true },
          },
          {
            path: 'nps/statistics',
            name: 'nps-statistics',
            component: () => import(/* webpackChunkName: "Statistic" */ '@/views/nps/Statistic.vue'),
            meta: { requiresAuth: true },
          }
        ]
      },
      {
        path: 'settings/systems/rights/:id/view',
        component: () => import(/* webpackChunkName: "RightView" */ '@/views/user/RightView.vue'),
        name: 'right-detail',
      },
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(m => m.meta.requiresAuth) && !store.getters['auth/isAuthenticated']) {
    return next({name: 'login'})
  }

  if (to.matched.some(m => m.meta.redirectIfAuthenticated) && store.getters['auth/isAuthenticated']) {
    return next({name: 'dashboard'})
  }

  return next()
})

export default router
